import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { getAuth0Config } from '../components/UtilsForAuth0';

const auth0 = getAuth0Config();

const Auth0ProviderWithConfig = ({ children }: { children: React.ReactNode }) => {
  if (!auth0.isActive) {
        return <>{children}</>;
    }
    let auth0_org = auth0.orgId;
    let redirect_uri = auth0.redirectUri;
  const orgParam = new URLSearchParams(window.location.search).get("organization");

    if (orgParam && orgParam.startsWith("org_")) {
      if(orgParam !== auth0_org){
        auth0_org = orgParam;
        redirect_uri = getAuth0Config(orgParam).redirectUri;
      }
    }
    return(
      <Auth0Provider
        domain={auth0.domain}
        clientId={auth0.clientId}
        authorizationParams={{
          redirect_uri,
          audience: auth0.audience,
          scope: "openid profile email read:current_user read:messages",
          organization: auth0_org
          //prompt: "none" // silent login attempt
        }}
        cacheLocation="localstorage" // Utiliser localStorage pour persister la session
        useRefreshTokens // Activer les refresh tokens pour des sessions plus longues
      >
        {children}
      </Auth0Provider>
);
};
export default Auth0ProviderWithConfig;
